import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ROLE_UK_ADMIN } from '../shared/constants';
import { DeclarationsAuthService } from './declarations-auth.service';
import { map, Observable, skipWhile } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UkAdminGuard {
  constructor(
    private authService: DeclarationsAuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.hasRole$(ROLE_UK_ADMIN).pipe(
      skipWhile((hasRole) => !hasRole),
      map((hasRole) => {
        if (hasRole) {
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      })
    );
  }
}
